export default "__VITE_ASSET__Dfeq$48r__"